export default __webpack_public_path__ + "static/media/cropped.bfa50326.png";